import { Box, Checkbox, Flex, Text } from '@chakra-ui/react'
import React from 'react'

interface Props {
    name: string
    price?: number
    isChecked: boolean
    handleClick: () => void
    disabled: boolean
    not_available: boolean
}

export default function ItemChecbox({
    name,
    isChecked,
    handleClick,
    disabled,
    price = 0,
    not_available
}: Props) {
    return (
        <Box
            as="label"
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            gap={2}
            minH="40px"
            py="2"
        >
            <Box>
                <Box>
                    <Text textDecor={not_available ? 'line-through' : 'none'}>
                        {name}
                    </Text>
                    {not_available && (
                        <Text color="red.400" fontSize="xs" lineHeight="1">
                            No disponible
                        </Text>
                    )}
                </Box>
                {price > 0 && (
                    <Flex alignItems={'center'} direction={'row'} gap={2}>
                        <Text>S/{price.toFixed(2)}</Text>
                    </Flex>
                )}
            </Box>
            <Checkbox
                onChange={() => handleClick()}
                isChecked={isChecked}
                size="lg"
                colorScheme="green"
                isDisabled={disabled || not_available}
            />
        </Box>
    )
}
